<template>
  <div>
    <van-cell-group>
      <van-field readonly clickable label="产品类目" :value="value" required placeholder="请选择产品分类" @click="showPicker = true" />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="columns" @change="onChange" value-key="categoryName" @cancel="showPicker = false"
          @confirm="onConfirm" :swipe-duration="300" />
      </van-popup>
      <van-field v-model="requiredInfo.shopName" label="店铺名称" placeholder="" required />
      <van-field v-model="requiredInfo.goodsName" label="宝贝名称" placeholder="" required />
      <!-- <van-field v-model="requiredInfo.goodsPoster" label="产品图片" placeholder=""/> -->
      <van-field v-model="otherInfo.goodsSpecifications" label="产品规格" placeholder="" />

      <div class="align van-cell van-cell--required van-field">
        <div class="van-cell__title van-field__label">佣金模式</div>
        <van-radio-group v-model="radio">
          <div class="align">
            <van-radio name="commission" checked-color="#07c160">佣金模式</van-radio>
            <div style="width: 20px"></div>
            <van-radio name="price" checked-color="#07c160">供货价模式</van-radio>
          </div>
        </van-radio-group>
      </div>
      <div class="van-cell-mode" v-if="radio==='commission'">
        <van-field v-model="commission.goodsSellReturn" label="佣金比例" placeholder="" required />
        <van-field v-model="commission.goodsSellReturnLinks" label="佣金链接" placeholder="" required />
        <van-field v-model="commission.goodsPriceTodayPage" label="当天页面价" placeholder="" required />
        <van-field v-model="commission.goodsPriceMin" label="最低价" placeholder="" required />
        <van-field v-model="commission.goodsPriceLive" label="直播价" placeholder="" required />
      </div>

      <div v-if="radio==='price'">
        <van-field v-model="price.wholesalePrice" label="批发供货价" placeholder="" required />
        <van-field v-model="price.oneGoodsPrice" label="一件代发价格" placeholder="" required />
      </div>

      <van-field v-model="otherInfo.preferentialWay" label="优惠方式" placeholder="" />
      <!-- <van-field v-model="otherInfo.couponLink" label="优惠券链接" placeholder="" /> -->

      <van-field v-model="requiredInfo.goodsLink" label="产品链接" placeholder="" required />
      <van-field v-model="requiredInfo.inventory" label="商品库存" placeholder="" required />

      <van-field v-model="otherInfo.liveDate" label="直播日期" placeholder="" />
      <van-field v-model="otherInfo.applicablePeople" label="孕妇是否可用" placeholder="" />
      <van-field v-model="otherInfo.other" label="其他" placeholder="" />
      <van-field v-model="requiredInfo.goodsAdvantages" label="卖点" autosize type="textarea" placeholder="" required />
      <van-field v-model="requiredInfo.contact" label="联系方式" placeholder="" required />
      <div class="align van-cell van-cell--required van-field">
        <div class="van-cell__title van-field__label">添加图片</div>
        <van-uploader v-model="fileList" multiple :after-read="sendPicture" :deletable="del">
          <van-button icon="photo" type="primary">上传图片</van-button>
        </van-uploader>
      </div>
    </van-cell-group>
    <div class="submit">
      <van-button type="primary" block @click="showInfo()">提交</van-button>
    </div>
  </div>
</template>

<script>
  var qiniu = require('qiniu-js')
  import category from './data'
  import axios from 'axios'
  import {
    Toast
  } from 'vant'
  const price = {
    // 批发价
    wholesalePrice: '',
    // 一件代发价格
    oneGoodsPrice: '',
  }
  const commission = {
    // 佣金比例
    goodsSellReturn: '',
    // 佣金链接
    goodsSellReturnLinks: '',
    // 当天页面价
    goodsPriceTodayPage: '',
    // 最低价
    goodsPriceMin: '',
    // 直播价
    goodsPriceLive: '',
  }
  const requiredInfo = {
    // 类目
    categoryId: '',
    // 店铺名称
    shopName: '',
    // 商品名称
    goodsName: '',

    goodsLink: '',

    // 库存
    inventory: '',
    // 优点
    goodsAdvantages: '',
    
    // 联系方式
    contact: ''
  }
  const otherInfo = {
    
    // 产品规格
    goodsSpecifications: '',
    // 优惠方式
    preferentialWay: '',
    // 优惠券链接
    couponLink: '',
    // 商品链接
    goodsLink: '',

    // 直播日期
    liveDate: '',
    // 孕妇 老人
    applicablePeople: '',
    // 其他
    other: '',
  }
  export default {
    data() {
      return {
        requiredInfo,
        otherInfo,
        commission,
        price,
        fileList: [],
        imgList: [],
        del: false,
        radio: 'commission',
        value: '',
        showPicker: false,
        avtiveIndex1: 0,
        avtiveIndex2: 0,
        columns: [],
      }
    },
    mounted() {
      this.columns = [{
          values: category,
          defaultIndex: 0
        },
        {
          values: category[this.avtiveIndex1].children,
          defaultIndex: 0
        },
        {
          values: category[this.avtiveIndex1].children[this.avtiveIndex2].children,
          defaultIndex: 0
        }
      ]
    },
    methods: {
      onConfirm(picker, value, index) {
        this.value = category[value[0]].children[value[1]].children[value[2]].categoryName
        this.requiredInfo.categoryId = category[value[0]].children[value[1]].children[value[2]].categoryId
        this.showPicker = false;
      },
      onChange(picker, values, index) {
        if(index===0) {
          picker.setColumnValues(1, values[0].children);
          picker.setColumnValues(2, values[0].children[0].children);
        }
        if(index===1) {
          picker.setColumnValues(2, values[1].children);
        }
        // this.$set(this, `columns[${index}].values`, )
      },
      showInfo() {
        let noneNum = 0

        switch(this.radio) {
          case 'commission':
            {
              const keys = Object.keys(this.requiredInfo).concat(Object.keys(this.commission));
              for (const key of keys) {
                const len = (this.requiredInfo[key] && this.requiredInfo[key].length || 0)
                 + (this.commission[key] && this.commission[key].length || 0);
                if (!len) {
                  noneNum++
                  break;
                }
              }
            }
            break;
          case 'price':
            {
              for (const key of Object.keys(this.requiredInfo).concat(Object.keys(this.price))) {
                const len = (this.requiredInfo[key] && this.requiredInfo[key].length || 0)
                 + (this.price[key] && this.price[key].length || 0);
                if (!len) {
                  noneNum++
                  break;
                }
              }
            }
            break;
        }

        if (noneNum) {
          this.$toast('有必填内容未填写，请检查之后再提交')
        } else {
          if(!this.fileList.length) {
            return this.$toast('请上传至少一张图片')
          }

          this.$post({
              road: 'operationsEvents',
              data: {
                operationsEventsId: 7
              },
              params: {
                content: {
                  ...this.requiredInfo,
                  ...this.otherInfo,
                  imgList: this.imgList,
                  radio: this.radio
                }
              },
              version: 'v2'
            })
            .then(res => {
              this.$toast('提交成功')
              this.requiredInfo = requiredInfo
              this.otherInfo = otherInfo
              
              this.fileList = []
              this.imgList = []
            })
            .catch(err => {
              this.$toast('提交失败')
            })
        }
      },
      sendPicture(val) {
        let _this = this;
        if (val.file.size / 1024 / 1024 > 2) {
          _this.$toast('图片大于2M，请缩小图片大小')
        } else {
          let putExtra = {
            fname: `${moment().unix()}${val.file.name}`,
            params: {},
            mimeType: null
          };
          var observer = {
            next(res) {
              if (res.total.percent < 100) {
                Toast.loading({
                  duration: 0,
                  message: `上传中，${res.total.percent.toFixed(2)}%`,
                  forbidClick: true,
                  loadingType: 'spinner'
                });
              } else {
                _this.$toast('上传成功')
                _this.imgList = _this.imgList.concat([putExtra.fname])
              }
            },
            error(err) {
              _this.$toast('上传失败')
            }
          }
          this.$get({
              road: 'qiniuToken',
              version: 'v2'
            })
            .then(res => {
              let token = res
              var observable = qiniu.upload(val.file, putExtra.fname, token)
              var subscription = observable.subscribe(observer)
            })
            .catch(err => {
              _this.$toast('上传失败')
            })
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  .submit {
    padding: .5rem .3rem;
  }
</style>
<style lang="less">
  .van-icon.van-icon-delete.van-uploader__preview-delete {
    display: none;
  }

  .van-cell::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
  }

  .van-cell-mode {

  }

</style>